import _ from 'lodash';
import SwooshableVideo from './swooshable-video';
import getYouTubeApi from '../get-youtube-api';
import {
  recordYoutubePlayStartStatistic,
  recordYoutubePlayFinishedStatistic,
} from '../../services/statistics-service';
import isUserSignedIn from '../is-user-signed-in';

const YOUTUBE_PLAYER_STATE = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  VIDEO_CUED: 5,
};

export default class SwooshableYouTubeVideo extends SwooshableVideo {
  constructor(iframe) {
    super(iframe);

    getYouTubeApi(YT => {
      this.player = new YT.Player(this.iframe);

      const wireId = $(`#${this.player.getIframe().id}`).parents('article.wire').data().id;

      // NOTE:
      // Also set up some behaviours around not being able to play when not
      // signed in and recording stats
      this.player.addEventListener('onStateChange', event => {
        if (event.data === YOUTUBE_PLAYER_STATE.PLAYING) {
          if (!isUserSignedIn() && !_.startsWith(window.location.pathname, '/wires/')) {
            this.player.stopVideo();
            window.location = '/sign_up';
            return;
          }

          recordYoutubePlayStartStatistic(wireId);
        } else if (event.data === YOUTUBE_PLAYER_STATE.ENDED) {
          recordYoutubePlayFinishedStatistic(wireId);
        }
      });
    });
  }

  get playing() {
    if (!this.player || !this.player.getPlayerState) return false;

    const state = this.player.getPlayerState();

    return state === YOUTUBE_PLAYER_STATE.PLAYING || state === YOUTUBE_PLAYER_STATE.BUFFERING;
  }
}
